module.exports = __webpack_public_path__ + "img/stub-espn-content--xl.6db97e6f.png";